function Error({error}) {
    return <div className="text-red-600 text-2xl bg-red-100">Error in your Key:{error} </div>
}
export default Error